import React, { useEffect, useState } from 'react';
import { SignIn as ClerkSignIn } from '@clerk/clerk-react';
import { Box, Heading, VStack, Text, Image } from '@chakra-ui/react';
import { useUser } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { saveUserData, checkUserExists } from '../../../services/userService';
import { useAuth } from '@clerk/clerk-react';
import Loader from '../../../components/common/Loader';

export function LoginFormPage() {
  const { isLoaded, user } = useUser();
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    const handleSignIn = async () => {
      if (isLoaded && isSignedIn && user) {
        setLoading(true);
        setError(null); // Reset error before request
  
        try {
          const { exists, role } = await checkUserExists(user.id);
  
          if (!exists) {
            try {
              const userData = {
                clerkId: user.id,
                email: user.emailAddresses[0].emailAddress,
                name: user.fullName,
              };
                await saveUserData(userData);
  
            } catch (error) {
              console.error('Error check user existance:', error);
              setError(error.message)
            }
            navigate('/')
          }
  
          // Redirect based on the user's role
          if (role === 'visitor') {
            navigate('/');
          } else if (role === 'student' || role === 'premium' || role ==='teacher') {
            navigate('/dashboard');
          }
  
        } catch (error) {
          console.error('Error:', error);
          setError(error.message || 'Something went wrong');
        } finally {
          setLoading(false);
        }
      }
    };
  
    handleSignIn();
  }, [isLoaded, isSignedIn, user, navigate]);
  

  if (loading) {
    return (
      <>
        <Text>Loading user...</Text>
        <Loader />
      </>
    );
  }

  if (error) {
    return <Text color="red.500">Error: {error}</Text>;
  }

  return (
    <Box 
      minH="100vh" 
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <VStack spacing={4} align="center">
        {isSignedIn ? (
          <>
            <Text>Welcome, {user.fullName}</Text>
            <Image src={user.imageUrl} alt={`${user.fullName}`} boxSize="10vh" />
          </>
        ) : (
          <>
            <Heading as="h3">התחברות</Heading>
            <Box maxW="400px" w="full">
              <ClerkSignIn signUpForceRedirectUrl={'/sign-in'} fallbackRedirectUrl={'/sign-in'} />
            </Box>
          </>
        )}
      </VStack>
    </Box>
  );
}

export default LoginFormPage;
